<div class="row">
  <div class="col-12">
    <sb-card [loading]="loading">
      <div card-fit>
        <sb-wizard [hideTabs]="true">
          <sb-wizard-tab titleText="{{ 'lang.wizard.tabs.generalSettings' | translate }}" icon="basicSettings"
                         [active]="true">
            <form [formGroup]="form" class="wizard__forms p-5">
              <h3 *ngIf="templateDatasetEntryId" class="my-4">{{'nav.templateDatasetEntries.edit' | translate}}</h3>
              <h3 *ngIf="!templateDatasetEntryId" class="my-4">{{'nav.templateDatasetEntries.create' | translate}}</h3>
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group validateMe">
                    <label class="form-label" for="Identifier">{{'lang.globals.identifier' | translate}}<span class="red">*</span></label>
                    <input type="text" id="Identifier" class="form-control" formControlName="Identifier" sbAutofocus>
                    <div *ngIf="Identifier.dirty && Identifier.errors?.required"
                         class="alert alert-danger">{{'lang.globals.uniqueIdentifierWarning' | translate}}</div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group validateMe">
                    <label class="form-label" for="Title">{{'lang.globals.name' | translate}}<span class="red">*</span></label>
                    <input type="text" id="Title" class="form-control" formControlName="Name">
                    <span class="form-text text-muted">{{'lang.planningEdit.nameDescription' | translate}}</span>
                    <div *ngIf="Name.dirty && Name.errors?.required"
                         class="alert alert-danger">{{'lang.planningEdit.nameWarning' | translate}}</div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group d-block">
                    <label class="form-label" for="Valid">{{'lang.globals.validity' | translate}}</label>
                    <div class="d-flex" id="Valid">
                      <sb-local-date-range-input [from]="from" [till]="till" [today]="null"
                                                 (dateChange)="handleDateChange($event)"></sb-local-date-range-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex flex-wrap gap-3 mb-5">
                <sb-comp-dropdown-select
                  [singleSelectMode]="true"
                  (msOptionsChange)="msRequest('TIME_CULLS', $event)"
                  (selectedDataEmitter)="update($event, 'TIME_CULLS')"
                  *ngPermissions="permissionService.Permission.cull_list" [dropDownDatatype]="'TIME_CULLS'"
                  [inputData]="timeCulls" [msOptions]="msTimeOptions"
                  [selectedInputData]="selectedTimeCull ? [selectedTimeCull] : []" [showColumnIcon]="false"
                  [showSubmit]="true">
                </sb-comp-dropdown-select>
                <sb-comp-dropdown-select
                  [singleSelectMode]="true"
                  (msOptionsChange)="msRequest('GEO_CULLS', $event)"
                  (selectedDataEmitter)="update($event, 'GEO_CULLS')"
                  *ngPermissions="permissionService.Permission.cull_list" [dropDownDatatype]="'GEO_CULLS'"
                  [inputData]="geoCulls" [msOptions]="msGeoOptions"
                  [selectedInputData]="selectedGeoCull ? [selectedGeoCull] : []" [showColumnIcon]="false"
                  [showSubmit]="true">
                </sb-comp-dropdown-select>
                <sb-comp-dropdown-select
                  [singleSelectMode]="true"
                  (msOptionsChange)="msRequest('PLAYER_CULLS', $event)"
                  (selectedDataEmitter)="update($event, 'PLAYER_CULLS')"
                  *ngPermissions="permissionService.Permission.cull_list" [dropDownDatatype]="'PLAYER_CULLS'"
                  [inputData]="playerCulls" [msOptions]="msPlayerOptions"
                  [selectedInputData]="selectedPlayerCull ? [selectedPlayerCull] : []" [showColumnIcon]="false"
                  [showSubmit]="true">
                </sb-comp-dropdown-select>

              </div>
              <table class="table mt-5">
                <thead>
                <tr>
                  <th>{{'lang.globals.templateVariables.name' | translate}}</th>
                  <th>{{'lang.globals.templateVariables.type' | translate}}</th>
                  <th>{{'lang.globals.templateVariables.value' | translate}}</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let variable of templateVariables; index as i">
                  <td>
                    {{variable?.name}}
                  </td>
                  <td>
                    {{variable?.type}}
                  </td>
                  <td class="form-group validateMe">
                    <div *ngIf="variable.type === TemplateVariableType.TEXT">
                      <input class="form-control" [(ngModel)]="templateDatasetEntry?.values[variable?.name]"
                             [value]="templateDatasetEntry?.values[variable?.name]"
                             [ngModelOptions]="{standalone: true}"
                             [class.ng-valid]="validate(variable?.name, variable?.type)"
                             [class.ng-invalid]="!validate(variable?.name, variable?.type)">
                      <span class="form-text text-muted">
                      {{'lang.globals.templateSourceEntries.text' | translate}}</span>
                    </div>
                    <div
                      *ngIf="variable.type === TemplateVariableType.IMAGE">
                      <input class="form-control" [(ngModel)]="templateDatasetEntry?.values[variable?.name]"
                             [value]="templateDatasetEntry?.values[variable?.name]"
                             [ngModelOptions]="{standalone: true}"
                             [class.ng-valid]="validate(variable?.name, variable?.type)"
                             [class.ng-invalid]="!validate(variable?.name, variable?.type)">
                      <span class="form-text text-muted">
                      {{'lang.globals.templateSourceEntries.image' | translate}}</span>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
              <div class="wizard__footerActions">
                <button
                  type="button"
                  (click)="navService.navigateToPoint(
                  util.RoutingID.templateDatasetEntries,
                  [{id: 'templateDatasetID', value: templateDatasetId}] ,
                   {queryParams: {collapse: templateDatasetId}})"
                  class="btn btn-default btn-lg btn-wide">{{'lang.globals.cancel' | translate}}</button>
                <button type="button" *ngIf="!templateDatasetEntryId" (click)="createTemplateDatasetEntry()" [disabled]="!(form.valid)|| loading"
                           class="btn btn-success btn-wide btn-lg">{{'lang.globals.submit' | translate}}</button>
                <button type="button" *ngIf="templateDatasetEntryId" (click)="updateTemplateDatasetEntry()"
                           [disabled]="!(form.valid && templateDatasetEntry) || loading"
                           class="btn btn-success btn-wide btn-lg">{{'lang.globals.save' | translate}}</button>
              </div>
            </form>
          </sb-wizard-tab>
        </sb-wizard>

      </div>
    </sb-card>
  </div>
</div>

